import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Linkedin from '../images/Linkedin-white.svg';
import Medium from '../images/Medium-white.svg';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
      });
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        fetch('https://formspree.io/meojoonz', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (response.ok) {
              alert('Message sent!');
              setFormData({ name: '', email: '', message: '' });
            } else {
              alert('Failed to send message. Please try again later.');
            }
          })
          .catch((error) => {
            alert('Failed to send message. Please try again later.');
          });
      };
      const handleHeartClick = () => {
  fetch('https://formspree.io/meojoonz', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: "Portfolio Visitor",
      email: "no-reply@yourdomain.com",
      message: "❤️ Someone clicked the heart to like your portfolio!",
    }),
  })
  .then((response) => {
    if (response.ok) {
      alert('Thanks for the love! ❤️');
    } else {
      alert('Failed to send like. Please try again.');
    }
  })
  .catch(() => {
    alert('Failed to send like. Please try again.');
  });
};

    return (
        <div>
          <Helmet>
            <title>Kshiti :: Contact</title>
          </Helmet>
            <section className="home-hero contact-kshiti">
                <div className="row">
                <div className="col home-hero-content">
                  <div className='contact-kshiti-content'>
                    <h1>
                      <span className="highlight-color">Get in Touch</span> with me.<br/>Let's talk.
                    </h1>
                    <h6><a href="kshitighelani@gmail.com">kshitighelani@gmail.com</a></h6>
                    <div className='contact-hero-social'>
                      <h6>Follow me:</h6>
                      <div className='contact-social-icons'>  
                        <a href='https://www.linkedin.com/in/kshiti-ghelani/' target='_blank' className='footer-social-logo'><img src={Linkedin} alt="Linkedin logo"/></a>
                        <a href='https://medium.com/@kshitighelani' target='_blank' className='footer-social-logo'><img src={Medium} alt="Medium logo"/></a>
                      </div>
                    </div>
                  </div>
                  <div className='contact-portfolio-like'>
  <p>Liked my portfolio?</p>
  <p>Press <span 
      className='portfolio-like-heart' 
      onClick={handleHeartClick} 
      style={{ cursor: 'pointer' }}
    >&#9829;</span> to show me some love.</p>
</div>

                </div>
                <div className="col">
                <div className="contact-form">
                    <h6>Say Hello!</h6>
                        <form onSubmit={handleSubmit}>
                            <div className='form-group-1'>
                            <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            </div>
                            <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            </div>
                            </div>
                            <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="10"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                            </div>
                            <div className='contact-button'>
                                <button type="submit">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;